import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { ScopeType } from "./types";

interface ScopeSelectorProps {
  selectedScope: ScopeType;
  onSelectScope: (scope: ScopeType) => void;
  shootAndEditPrice: number;
  shootOnlyPrice: number;
  currency?: string;
}

const ScopeSelector = ({
  selectedScope,
  onSelectScope,
  shootAndEditPrice,
  shootOnlyPrice,
  currency = "₹",
}: ScopeSelectorProps) => {
  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-foreground">Choose your scope:</h4>

      <div className="space-y-3">
        {/* Shoot + Edit Option */}
        <button
          onClick={() => onSelectScope("shoot_and_edit")}
          className={cn(
            "w-full flex items-center gap-3 p-4 rounded-lg border transition-all duration-200 text-left",
            selectedScope === "shoot_and_edit"
              ? "border-primary bg-primary/5"
              : "border-border hover:border-primary/30"
          )}
        >
          <div
            className={cn(
              "w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all",
              selectedScope === "shoot_and_edit"
                ? "bg-primary border-primary"
                : "border-border"
            )}
          >
            {selectedScope === "shoot_and_edit" && (
              <div className="w-2 h-2 rounded-full bg-primary-foreground" />
            )}
          </div>
          <div className="flex-1">
            <span className="text-sm font-medium text-foreground">
              Shoot + Edit
            </span>
            <span className="text-sm text-muted-foreground">
              {" "}
              — {currency}
              {shootAndEditPrice.toLocaleString()}/video{" "}
            </span>
            <span className="text-sm text-muted-foreground">(meets </span>
            <span className="text-sm font-medium text-foreground">
              editing benchmark
            </span>
            <span className="text-sm text-muted-foreground">)</span>
          </div>
        </button>

        {/* Shoot Only Option */}
        <button
          onClick={() => onSelectScope("shoot_only")}
          className={cn(
            "w-full flex items-center gap-3 p-4 rounded-lg border transition-all duration-200 text-left",
            selectedScope === "shoot_only"
              ? "border-primary bg-primary/5"
              : "border-border hover:border-primary/30"
          )}
        >
          <div
            className={cn(
              "w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all",
              selectedScope === "shoot_only"
                ? "bg-primary border-primary"
                : "border-border"
            )}
          >
            {selectedScope === "shoot_only" && (
              <div className="w-2 h-2 rounded-full bg-primary-foreground" />
            )}
          </div>
          <div className="flex-1">
            <span className="text-sm text-muted-foreground">Shoot only</span>
            <span className="text-sm text-muted-foreground">
              {" "}
              — {currency}
              {shootOnlyPrice.toLocaleString()}/video (raw footage delivery)
            </span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ScopeSelector;
